<template>
  <ul class="user-type">
    <li
      v-for="(user, i) in $constants.USER_TYPE"
      :key="i"
      @click="changeUserType(user)"
      class="user-type__item"
      :class="{ 'user-type__item--active': user === userType }"
    >
      {{ $t(`user_type_${user}`) }}
    </li>
  </ul>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UserType',
  props: {
    reloadPage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      userType: state => state.user.userType
    })
  },
  methods: {
    ...mapActions(['CHANGE_USER_TYPE']),
    changeUserType (type) {
      this.CHANGE_USER_TYPE(type).then(res => {
        if (res.data?.status === 'success' && this.reloadPage) location.reload()
      })
    }
  }
}
</script>

<style scoped lang="sass">

.user-type
  +list-unstyled
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  width: 100%
  padding: 4px
  border-radius: 3px
  background-color: #f5f5f5

.user-type__item
  display: flex
  justify-content: center
  align-items: center
  width: 48%
  border-radius: 3px
  background: transparent
  cursor: pointer
  padding: 4px
  color: $text-color

  &--active
    background-color: $white-text-color

</style>
